import React from 'react';
import Grid from '@material-ui/core/Grid';
import MDXParser from '../mdxParser';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import FundingFiguresSVG from '../fundingFigures';
import LargestContributionsSVG from '../largestContributions';
import ECContributionsSVG from '../ecContribitions';
import FundingFiguresContent from '../../sections/FundingFigures/FundingFigures';

import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: '60px 0',
    },
    list: {
      display: 'flex',
      flexDirection: 'column',
      padding: '20px',
    },
    nestedList: {
      display: 'flex',
      flexDirection: 'column',
      padding: '0px 20px',
    },
    listItem: {
      paddingLeft: '0px',
    },
    memberStates: {
      backgroundColor: '#0076bc',
      color: '#0076bc',
      height: '20px',
      width: '20px',
    },
    europeanCommision: {
      backgroundColor: '#04add7',
      color: '#04add7',
      height: '20px',
      width: '20px',
    },
    memberStatesEc: {
      backgroundColor: '#034ea1',
      color: '#034ea1',
      height: '20px',
      width: '20px',
    },
    white: {
      backgroundColor: 'white',
      padding: '20px 15px',
    },
    title: {
      color: '#191a19',
    },
    subtitle: {
      margin: '30px 0'
    },
    dgEcho: {
      backgroundColor: '#f47720',
      color: '#f47720',
      height: '20px',
      width: '20px',
    },
    dgDevco: {
      backgroundColor: '#833443',
      color: '#833443',
      height: '20px',
      width: '20px',
    },
    dgNear: {
      backgroundColor: '#f0ba89',
      color: '#f0ba89',
      height: '20px',
      width: '20px',
    },
  }),
);

type Props = { children: React.ReactNode; image: string };

const FundingFiguresSection = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={12}>
          <MDXParser>
            <FundingFiguresContent />
          </MDXParser>
        </Grid>
        <Grid container  className={classes.white}>
          <Grid item xs={12} md={6}>
            <Typography variant="h3" className={classes.title}>
              NEW EU FUNDING IN 2019
            </Typography>
            <List dense={false} className={classes.list}>
              <ListItem className={classes.listItem}>
                <ListItemAvatar>
                  <Avatar className={classes.memberStates}></Avatar>
                </ListItemAvatar>
                <ListItemText className={classes.title} primary="EU Member states" />
              </ListItem>
              <ListItem className={classes.listItem}>
                <ListItemAvatar>
                  <Avatar className={classes.europeanCommision}></Avatar>
                </ListItemAvatar>
                <ListItemText className={classes.title} primary="European Commission (EC)" />
              </ListItem>
              <List dense={true} className={classes.nestedList}>
                <ListItem className={classes.listItem}>
                  <ListItemAvatar>
                    <Avatar className={classes.dgEcho}></Avatar>
                  </ListItemAvatar>
                  <ListItemText className={classes.title} primary="ECHO" />
                </ListItem>
                <ListItem className={classes.listItem}>
                  <ListItemAvatar>
                    <Avatar className={classes.dgNear}></Avatar>
                  </ListItemAvatar>
                  <ListItemText className={classes.title} primary="NEAR" />
                </ListItem>
                <ListItem className={classes.listItem}>
                  <ListItemAvatar>
                    <Avatar className={classes.dgDevco}></Avatar>
                  </ListItemAvatar>
                  <ListItemText className={classes.title} primary="DEVCO" />
                </ListItem>
              </List>
              <ListItem className={classes.listItem}>
                <ListItemAvatar>
                  <Avatar className={classes.memberStatesEc}></Avatar>
                </ListItemAvatar>
                <ListItemText className={classes.title} primary="EU Member States + EC" />
              </ListItem>
            </List>
          </Grid>
          <Grid item xs={12} md={4}>
            <FundingFiguresSVG />
          </Grid>

          <Grid item xs={12} md={8}>
            <Typography variant="h3" className={classes.subtitle}>
              LARGEST EC CONTRIBUTIONS TO WFP IN 2019
            </Typography>
            <LargestContributionsSVG />
          </Grid>

          <Grid item xs={12} md={8}>
            <Typography variant="h3" className={classes.subtitle}>
              EC CONTRIBUTIONS TO WFP IN THE PAST THREE YEARS
            </Typography>
            <ECContributionsSVG />
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default FundingFiguresSection;
